// extracted by mini-css-extract-plugin
export default {"tags":"dsT41CUU0UPkY5LbadJA","tag":"skrdT44B9JH1MMz4lanQ"};